export const api = {
    "$status": "pouziva se /2026",
    "dev_root": "http://fifth.api/v",
    "root": "https://dev-api.jiri5.cz/v3", //asi se nepouziva
    "header_name": "X-Fifth-Cms-User",
    "topic": {
        "select_list_service": {
            "method": "get",
            "path": "/class/topic/list-template",
            "input": {
                "id": "galerie_id"
            }
        },
    },
    "user": {
        //"login_path": "/class/user/login",
        //"x_login_check": "/class/user/check-user",
        //"logout_path": "/class/user/logout",
        "preview": {
            "path": "/class/user-manager/preview?user_id="
        },
        "select_list_service": {
            "method": "get",
            "path": "/class/user-manager/list-template",
            "input": {
                "id": "galerie_id"
            }
        },
        "create_reset_request": {
            "method": "post",
            "path": "/class/user-manager/create-reset-request",
            "input": {
                "login": "login",
            }
        },
        "password_reset_check_hash": {
            "method": "post",
            "path": "/class/user-manager/password-reset-check-hash",
            "input": {
                "user_id": "user_id",
                "hash": "hash",
            }
        },
        "password_reset_setup_new": {
            "method": "post",
            "path": "/class/user-manager/password-reset-setup-new",
            "input": {
                "user_id": "user_id",
                "hash": "hash",
                "password": "password",
                "password_confirm": "password_confirm",
            }
        },
        "check_password": {
            "method": "post",
            "path": "/class/user-manager/check-password",
            "input": {
                "password": "password",
                "password_confirm": "password_confirm",
            }
        },
        "google_login": {
            "method": "post",
            "path": "/class/user-manager/google-login",
            "input": {
            }
        },
        "login": {
            "method": "get",
            "path": "/class/user-manager/login",
            "input": {
            }
        },
        "logout": {
            "method": "post",
            "path": "/class/user-manager/logout",
            "input": {
            }
        },
        "login_check": {
            "method": "get",
            "path": "/class/user-manager/check-user",
            "input": {
            }
        },
        "check_messages": {
            "method": "post",
            "path": "/class/user-manager/check-password",
            "input": {
                "password": "password",
                "password_confirm": "password_confirm",
            }
        },
        "check_flash_messages": {
            "method": "get",
            "path": "/class/flash-message/notifications",
        },
        "read_flash_messages": {
            "method": "get",
            "path": "/class/flash-message/notification-read",
            "input": {
                "flash_id": "flash_id",
            }
        },
        "read_push_messages_by_id": {
            "method": "get",
            "path": "/class/push-notification/notification-read-by-id",
            "input": {
                "flash_id": "flash_id",
            }
        },
        "unread_push_messages": {
            "method": "get",
            "path": "/class/push-notification/my-unread-notifications",
            "input": {
                "flash_id": "flash_id",
            }
        },

    },
    "product": {
        "select_list_service": {
            "method": "get",
            "path": "/class/eshop-catalog/list-template",
            "input": {
                "id": "galerie_id"
            }
        },
    },
    "general": {
        "info": {
            "method": "get",
            "path": "/class/general/login-screen-info",
        },
        "main_menu": {
            "method": "get",
            "path": "/class/general/main-menu"
        },
        //"main_menu_path": "/class/general/main-menu",
        "dashboards": {
            "method": "get",
            "path": "/class/general/dashboard",
        },
        "format_slug": {
            "method": "get",
            "path": "/class/general/format-slug",
            "input": {
                "slug": "slug"
            }
        },
        "welcome_screen": {
            "method": "get",
            "path": "/class/general/welcome-screen",
        },
        "openLink": {
            "method": "get",
            "path": "/class/general/redirect-to-frontend",
        },
    },
    "gallery": {
        "preview": {
            "method": "get",
            "path": "/class/gallery/preview",
            "input": {
                "id": "galerie_id"
            }
        },
        "detail": {
            "method": "get",
            "path": "/class/gallery/detail-service",
            "input": {
                "id": "id"
            }
        },

        "browse_service": {
            "method": "get",
            "path": "/class/gallery/list-select",
            "input": {
                "query": "q"
            }
        },
        "images_service": {
            "method": "get",
            "path": "/class/gallery/image-list",
            "input": {
                "query": "id"
            }
        },
        "save_service": {
            "method": "post",
            "path": "/class/gallery/save-simple",
        },
        "upload_service": {
            "method": "post",
            "path": "/class/gallery/upload",
            "input": {
                "file_name": "image_file"
            }
        },
        "create_service": {
            "method": "post",
            "path": "/class/gallery/create-simple",
            "input": {
                "title": "gallery_title",
                "validation": "validation"
            },
            "upload_max_files": 30
        },
        "server_upload_list": {
            "method": "post",
            "path": "/class/gallery/server-upload",
            "input": {
                "title": "gallery_title",
                "validation": "validation"
            }
        },
        "stats_service": {
            "method": "get",
            "path": "/class/gallery/gallery-stat",
            "input": {
                "di": "gallery_id",
            }
        },
    },
    "image": {
        "upload_service": {
            "method": "post",
            "path": "/class/image/upload",
            "input": {
                "file_name": "image_file"
            }
        },
        "save_info": {
            "method": "post",
            "path": "/class/image/save-info",
            "input": {
                "image": "image"
            }
        },
        "get_info_tags": {
            "method": "get",
            "path": "/class/image/image-tags?image_id=",
        },
        "server_upload_service": {
            "method": "post",
            "path": "/class/image/server-upload",
            "input": {
                "name": "file_name",
                "file_path": "image_path",
                "image_type": "image_type",
                "delete": "delete_after_upload",
                "validate": "image_validation",
            }
        },
        "browse_service": {
            "method": "get",
            "path": "/class/image/image-select-list",
            "input": {
                "type": "typ_id",
                "query": "q"
            }
        },
        "preview": {
            "path": "/class/image/preview?image_id=",
            "method": "get",
        },
        "detail": {
            "path": "/class/image/detail-full?image_id=",
            "method": "get",
        },
        "detail_sizes": {
            "method": "get",
            "path": "/class/image/detail-sizes?image_id=",
        },
        "server_upload_thumbnail": {
            "path": "/class/image/display-thumbnail-upload?file="
        },
    },
    "obsah": {
        "link": {
            "path": "/class/content/clanek-select-list?q="
        },
        "link_content": {
            "path": "/class/content/obsah-select-list?q="
        },
        "create_anotation": {
            "method": "post",
            "path": "/class/content/create-anotation",
            "input": {
                "segment": "segment"
            }
        },
        "scan_text": {
            "method": "post",
            "path": "/class/content/scan-text",
            "input": {
                "text": "text"
            }
        },
        "segments_prefill": {
            "method": "post",
            "path": "/class/content/segments-by-id",
            "input": {
                "ids": "ids"
            }
        },
    }  ,
    "wysiwyg": {
        "buttons": {
            "method": "get",
            "path": "/class/content/wysiwig-buttons"
        },
        "dev": {
            "path": "/class/content/dev-wysiwig-editor-dialog"
        },
    },
    "tags": {
        "popularTagName": 'tagsPopular',
        "popularTagLimit": 20,
        "create_simple": {
            "path": "/class/tags/create-simple"
        },
        "select_list": {
            "path": "/class/tags/list-select?q="
        }
    },
    reservation: {
        module: "reservation-slot"
    },
    "restaurace": {
        "modules": {
            "section": "restaurant-menu-section",
            "meal": "restaurant-meal",
        },
        "get_structure": {
            "method": "get",
            "path": "/class/restaurant-menu/section-list-select",
            "input": {
                "id": "id"
            }
        },
        "meal_search": {
            "method": "get",
            "path": "/class/restaurant-meal/list-select",
            "input": {
                "restaurace": "restaurace_id",
                "query": "q"
            }
        },
        "meal_detail": {
            "method": "get",
            "path": "/class/restaurant-meal/detail",
            "input": {
                "id": "id",
            }
        },
    },
    "redirect": {
        "get_new_hash": {
            "method": "get",
            "path": "/class/presmerovani/get-new-hash",
        },
    },
    "venue": {
        "get_parent_venue": {
            "method": "post",
            "path": "/class/venue/venue-parent",
            "input": "place",
        },
        "get_venue_formated": {
            "method": "post",
            "path": "/class/venue/venue-formated",
            "input": "place",
        },

        "get_result_list": {
            "method": "post",
            "path": "/class/venue/results-venue-list",
            "input": "list_input",
        },
        "get_detail": {
            "method": "get",
            "path": "/class/venue/detail-full?id=",
        },
        "get_options_list": {
            "method": "get",
            "path": "/class/venue/options-list",
            "input": "q",
        },
        "get_list_from_gps": {
            "method": "post",
            "path": "/class/venue/gps-list",
            "input": "qps",
        },
        "get_list_around_from_gps": {
            "method": "post",
            "path": "/class/venue/gps-list-circle",
            "input": "qps",
        },


    },
    "eshop": {
        "get_tax_detail": {
            "method": "get",
            "path": "/class/eshop-tax/detail",
            "input": {
                "id": "id"
            }
        },
        "get_parametr_list": {
            "method": "get",
            "path": "/class/eshop-produkt/parametr-list",
            "input": {
                "id": "id"
            }
        },
        "get_detail_parametr_value": {
            "method": "get",
            "path": "/class/eshop-produkt/parametr-detail",
            "input": {
                "id": "id"
            }
        },
        "add_parametr_value": {
            "method": "post",
            "path": "/class/eshop-produkt/parametr-add",
            "input": {
                "parametr_id": "id",
                "value": "value"
            }
        },

    },
    "rezervace": {
        "view_prehled_slot_detail": {
            "method": "post",
            "path": "/class/rezervace-slot/view-prehled-slot-detail",
            "input": {
                "slot": "slot"
            }
        },
        "slot_change_slot_status": {
            "method": "post",
            "path": "/class/rezervace-slot/change-status",
            "input": {
                "slot_id": "slot_id",
                "stav_id": "stav_id"
            }
        },
    },
    "dashboard": {
        "detail": {
            "method": "get",
            "path": "/class/dashboards/dashboard-detail",
            "input": {
                "id": "id"
            }
        },
    },
    "wiki": {
        "load_types": {
            "method": "get",
            "path": "/class/wiki/type-list",
            "input": {
                "type": "typ_id"
            }
        },
        "check_url": {
            "method": "get",
            "path": "/class/wiki/check-url",
            "input": {
                "type": "type",
                "url": "url"
            }
        },
    },
    "invoice": {
        "find_organization": {
            "method": "post",
            "path": "/class/invoice-company/search-organization-by-id",

        },
        "find_organization_by_vat": {
            "method": "post",
            "path": "/class/invoice-company/search-organization-by-vat",

        },
        "find_organization_by_vendor": {
            "method": "get",
            "path": "/class/invoice-company/client-list-by-vendor",
            "input": {
                "id": "id",
               }
        },

        "save_organization": {
            "method": "post",
            "path": "/class/invoice-company/save-organization",
            "input": {
                "data": "data",
                "is_vendor": "is_vendor",
                "parent_id": "parent_id",
            }
        },
    },
    "gift_coupon": {
        "validate_code": {
            "method": "post",
            "path": "/class/gift_coupon/validate-code",
        },
        "apply_code": {
            "method": "post",
            "path": "/class/gift_coupon/apply-code",
        },
    },
    "notification": {
        "unread_count": {
            "method": "get",
            "path": "/class/push-notification/unread-count",
            "input": {
                "token": "fcm_token"
            }
        },
        "save_fcm_token": {
            "method": "post",
            "path": "/class/user-manager/save-push-notification-token",
            "input": {
                "token": "fcm_token"
            }
        }
    },
    "file": {
        "uploadChunk": {
            "method": "post",
            "path": "/class/file/upload-chunk",
            "input": {
                "file_name": "file_name"
            }
        },
        "download": {
            "method": "post",
            "path": "/class/file/download",
            "input": {
                "id": "id"
            }
        },
    }
};
